import ArticleCmsIndex from './components/pages/articleBO/index';
customElements.define('cms-article-index', ArticleCmsIndex,{extends: 'div'});